import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';

export const MaterialSelect = styled(Select)(({ theme, ...props }) => ({
  border: `1px solid ${props.required ? theme.palette.colors.required : theme.palette.colors.shadow}`,
  height: '48px',
  borderRadius: '4px',
  padding: '0 8px',
}));
